/* PAWLY V11 · comportements discrets (apparitions, en-tête, menu) */
(function () {
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Dans l'éditeur Shopify, tout s'affiche directement : les sections sont rechargées à chaque modification */
  var design = !!(window.Shopify && window.Shopify.designMode);
  var io = null, ioImg = null;
  if ('IntersectionObserver' in window && !reduce && !design) {
    var watch = function (threshold) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: threshold });
      return obs;
    };
    io = watch(0.08);
    /* Images : le clip-path de départ les rend visibles à 0 % pour l'observer, on déclenche dès l'entrée */
    ioImg = watch(0);
  }

  function show(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-delay')) setTimeout(function () { el.removeAttribute('data-delay'); }, 1500);
  }

  function boards(scope) {
    scope.querySelectorAll('.pw-avent__board').forEach(function (board) {
      board.querySelectorAll('.pw-tag').forEach(function (t, i) {
        if (design) return;
        t.style.transitionDelay = (i * 0.035).toFixed(3) + 's';
        t.addEventListener('transitionend', function () { t.style.transitionDelay = ''; }, { once: true });
      });
    });
  }

  function reveal(scope) {
    var els = scope.querySelectorAll('[data-reveal], .pw-avent__board');
    els.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      if (!io) { show(el); return; }
      (el.getAttribute('data-reveal') === 'img' ? ioImg : io).observe(el);
    });
    boards(scope);
  }

  reveal(d);

  /* Éditeur de thème : une section modifiée est remplacée, on la réaffiche aussitôt */
  d.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest ? e.target.closest('section, .shopify-section') : null;
    if (s) reveal(s);
  });

  /* En-tête : filet discret après le premier scroll */
  var head = d.querySelector('.pw-head');
  if (head) {
    var onScroll = function () { head.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Menu mobile (délégation : continue de marcher après un rechargement de l'en-tête) */
  function setMenu(open) {
    var menu = d.getElementById('pw-menu');
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.body.classList.toggle('pw-noscroll', open);
    d.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var first = menu.querySelector('a, button'); if (first) first.focus(); }
  }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) setMenu(true);
    else if (e.target.closest('[data-menu-close]')) setMenu(false);
  });
  d.addEventListener('keydown', function (e) {
    var menu = d.getElementById('pw-menu');
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false);
  });
})();